import React from 'react';
import { useTheme } from 'styled-components';

import { BUTTON_TYPES } from '@savgroup-front-common/constants';
import { Button } from '@savgroup-front-common/core/atoms/button';
import { Heading } from '@savgroup-front-common/core/atoms/Heading';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { SUPPORTED_ICON_POSITIONS } from '@savgroup-front-common/core/helpers';
import { ArrowNakedRightIcon } from '@savgroup-front-common/core/protons/icons/ArrowNaked/ArrowNakedRight.icon';
import { MyAccountIcon } from '@savgroup-front-common/core/protons/IconsNewDesign/MyAccount.icon';
import { FLEX_ALIGN, ICONS_TYPE } from '@savgroup-front-common/types';
import IconDiagnosticTreeEntry from '@/view/components/IconDiagnosticTreeEntry';

import messages from '../messages';

import {
  $RowButtonContainer,
  $RowContainer,
  $SubtitleContainer,
} from './ClaimGroupReasonPageDiagnosticTreeEntry.styles';

interface ClaimGroupReasonPageDiagnosticTreeEntryProps {
  onRefuseDiagnosticTree: () => void;
  onAcceptDiagnosticTree: () => void;
}

const ClaimGroupReasonPageDiagnosticTreeEntry: React.FC<
  ClaimGroupReasonPageDiagnosticTreeEntryProps
> = ({ onRefuseDiagnosticTree, onAcceptDiagnosticTree }) => {
  const theme = useTheme();

  return (
    <>
      <$RowContainer center="xs">
        <IconDiagnosticTreeEntry />
        <Heading level={2} align={FLEX_ALIGN.CENTER} color={theme.colors.black}>
          <SafeFormattedMessageWithoutSpread
            message={messages.diagnosticTreeTitle}
          />
        </Heading>
        <$SubtitleContainer>
          <MyAccountIcon
            icon={ICONS_TYPE.VEGAN_CIRCLE_ICON}
            color={theme.colors.success}
          />
          <SafeFormattedMessageWithoutSpread
            message={messages.diagnosticTreeSubtitle}
          />
        </$SubtitleContainer>

        <$RowButtonContainer>
          <Button
            type={BUTTON_TYPES.BUTTON}
            underline
            onClick={() => onRefuseDiagnosticTree()}
            dataTestId="refuse-diagnostic-tree"
          >
            <SafeFormattedMessageWithoutSpread
              message={messages.diagnosticTreeButtonBack}
            />
          </Button>
          <Button
            type={BUTTON_TYPES.BUTTON}
            primary
            icon={<ArrowNakedRightIcon />}
            position={SUPPORTED_ICON_POSITIONS.RIGHT}
            onClick={() => onAcceptDiagnosticTree()}
            dataTestId="go-diagnostic-tree"
          >
            <SafeFormattedMessageWithoutSpread
              message={messages.diagnosticTreeButtonGo}
            />
          </Button>
        </$RowButtonContainer>
      </$RowContainer>
    </>
  );
};

export default ClaimGroupReasonPageDiagnosticTreeEntry;
